import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { BiLayer } from 'react-icons/bi'
import { MdOutlineQrCode } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'

import { Box, Flex, Icon } from '@chakra-ui/react'

import { GuardTour, SecurityDevice } from '@/components/icons'
import { HeaderDrawerToggle } from '@/components/ui'
import { selectMe } from '@/redux/me/meSlice'
import {
  openFacilityCheckpointsDrawer,
  openFacilityDevicesDrawer,
  openFacilityFloorsDrawer,
  openFacilityTourPlansDrawer,
  selectFacilityDrawerOpen,
} from '@/redux/ui/uiSlice'
import { mixpanel } from '@/utils/analytics'

const Divider = () => {
  return <Box bgColor='#D0CCCC' h='20px' rounded='full' w='2px' />
}

interface HeaderDrawerTogglesIProps {
  facilityId: string
  placedDeviceCount: number
  floorCount: number
  checkpointCount: number
  tourPlansCount: number
}

export const HeaderDrawerToggles = ({
  facilityId,
  placedDeviceCount,
  floorCount,
  checkpointCount,
  tourPlansCount,
}: HeaderDrawerTogglesIProps) => {
  const me = useSelector(selectMe)
  const dispatch = useDispatch()
  const drawerOpen = useSelector(selectFacilityDrawerOpen)
  const isGuardToursEnabled = useFeatureFlag(FeatureFlag.guardTours)

  return (
    <Flex alignItems='center' mr='6'>
      <HeaderDrawerToggle
        count={placedDeviceCount}
        dataTestId='floorPlanPage_header_devicesCount'
        icon={<Icon as={SecurityDevice} boxSize='28px' strokeColor='#000' />}
        isActive={drawerOpen === 'devices'}
        onClick={() => dispatch(openFacilityDevicesDrawer())}
        title='Device Placement'
      />
      <Divider />
      <HeaderDrawerToggle
        count={floorCount}
        dataTestId='floorPlanPage_header_floorsCount'
        icon={<BiLayer color='#1a202c' size='28px' />}
        isActive={drawerOpen === 'floors'}
        onClick={() => dispatch(openFacilityFloorsDrawer())}
        title='Floors'
      />
      {isGuardToursEnabled && (
        <>
          <Divider />
          <HeaderDrawerToggle
            count={checkpointCount}
            dataTestId='floorPlanPage_header_checkpointsCount'
            icon={<MdOutlineQrCode color='#1a202c' size='28px' />}
            isActive={drawerOpen === 'checkpoints'}
            onClick={() => {
              dispatch(openFacilityCheckpointsDrawer())
              mixpanel.track('Button Press: Facility Checkpoints', {
                facility_id: facilityId,
                role: me.roleName,
              })
            }}
            title='Checkpoints'
          />
          <Divider />
          <HeaderDrawerToggle
            count={tourPlansCount}
            dataTestId='floorPlanPage_header_tourPlanCount'
            icon={<Icon as={GuardTour} boxSize='24px' strokeColor='#000' />}
            isActive={drawerOpen === 'tour-plans'}
            onClick={() => {
              dispatch(openFacilityTourPlansDrawer())
              mixpanel.track('Button Press: Facility Tour Plans', {
                facility_id: facilityId,
                role: me.roleName,
              })
            }}
            title='Tour Plans'
          />
        </>
      )}
    </Flex>
  )
}
